import Vue from "vue";
import { store, storeFuns, api, apiFuns } from "sw-hic";

storeFuns.init({
  state: {
    enum: {
      HospitalizationState: ["已登记", "已入住", "已撤销", "已离院", "已结算"],
      DepositType: ["收费", "退费"],
      DepositOccasion: ["入院缴费", "在院补缴", "离院补缴", "离院退费"],
      SettlementStatus: ["未结算", "已结算"],
      AuditState: ["草稿", "审批中", "通过", "拒绝"],
      CriticalLevel: ["濒危", "危重", "急症", "非急症"],
      IpType: ["自费", "医保", "医保工伤"],
      BillType: ["出院单据号", "住院号"],
      DiagnosisType: ["西医", "中医"],
      AdviceType: ["药品", "医技", "草药", "转科", "离院", "嘱托"],
      AdviceTerm: ["临时", "长期"],
      AdviceState: ["草稿", "待校对", "废弃", "退回", "启用", "暂停", "待停止", "停止"],
      ReasonList: ["剂量错误", "用法错误", "频次错误", "执行科室错误", "药品无库存", "重复", "无法会诊"],
      InsuranceRange: ["医保内", "医保外"],
      RpClass: ["药品", "草药", "检查", "检验", "治疗", "材料"],
      PatientGroup: ["留置看护", "武警看护"],
      LisRecordState: ["待接收", "待检验", "样本拒收", "报告发出"],
      PacsRecordState: ["待检查", "报告发出"],
    },
    notifyIpNos: [],
  },
});
api.Storehouse = apiFuns.genStandard("storehouse", "/api/drug", true);
storeFuns.genDict("Storehouse", () => api.Storehouse.query({ type: "药房" }));
api.Frequency = apiFuns.genStandard("frequency", "/api/md", true);
storeFuns.genDict(
  "DrugFrequency",
  () => api.Frequency.query({ forIp: true }),
  "name",
  "code",
  "shortCode",
  (store, dict) => {
    dict.items.forEach((item) => {
      item.text = `${item.name} ${item.dailyTime}`;
      item.code = item.code;
      item.shortCode = item.shortCode;
      item.value = item.code;
    });
    store.commit("dict", dict);
  }
);
export default store;

// 常驻一个消息处理，定时刷新获取最新医嘱情况
let msg = new Vue({
  data() {
    return {
      execTime: null,
      deptCode: null,
    };
  },
  methods: {
    getNew() {
      apiFuns.get("/api/proxy/adviceExec/info", {}).then((res) => {
        if (res.isRunning) {
          return;
        }

        if (!store.getters.user) return;
        if (this.deptCode !== store.getters.user.deptCode) {
          this.execTime = null;
          this.deptCode = store.getters.user.deptCode;
        } 
        apiFuns
          .get("/api/ip/advice", {
            deptCode: store.getters.user.deptCode,
            states: ["待校对", "待停止"],
            ifDetail: false,
            isMaster: true,
            updateDateStart: this.execTime,
          })
          .then((res) => {
            this.execTime = this.$utils.Dt.now();
            if (res.items.length) {
              let l = res.items.filter((i) => i.state === "待校对").length;
              if (l) this.show(l, "校对", "warning", "warning");
              this.$nextTick(() => {
                l = res.items.filter((i) => i.state === "待停止").length;
                if (l) this.show(l, "停止", "error", "danger");
              });
              store.state.notifyIpNos = res.items.map((item) => item.ipNo);
            }
          });
      });
    },
    show(cnt, act, type, link) {
      const h = this.$createElement;
      this.$notify({
        // offset: 50,
        position: "bottom-right",
        duration: 0,
        title: "",
        type: type,
        message: h("el-link", { props: { href: "/#/advice", type: link }, attrs: { style: "margin-top:-0.5rem; " } }, `${cnt} 条医嘱需要${act}`),
      });
    },
  },
});
msg.getNew();
setInterval(() => {
  msg.getNew();
}, store.getters.setting?.refreshSpan || 30000);

// 常驻一个消息处理，定时刷新获取Lis处理提醒
let msgLis = new Vue({
  data() {
    return {
      notification: null,
    };
  },
  methods: {
    getNew() {
      apiFuns
        .get("/api/proxy/lisRecord/warning", {})
        .then((res) => {
          if (this.notification) {
            this.notification.close();
            this.notification = null;
          }
          if (res.rejects.length) {
            this.show(res.rejects.length, "处理", "error", "danger");
          }
        });
    },
    show(cnt, act, type, link) {
      const h = this.$createElement;
      this.notification = this.$notify({
        // offset: 50,
        position: "bottom-left",
        duration: 0,
        title: "",
        type: type,
        message: h("el-link", { props: { href: "/#/testReject", type: link }, attrs: { style: "margin-top:-0.5rem; " } }, `${cnt} 条检验送检样本拒收需${act}`),
      });
    },
  },
});
msgLis.getNew();
setInterval(() => {
  msgLis.getNew();
}, 30000);
